
    import './styles.scoped.css';
    export default {
  "layout": "awsui_layout_5gtk3_5g7ct_97",
  "background": "awsui_background_5gtk3_5g7ct_111",
  "is-overlap-disabled": "awsui_is-overlap-disabled_5gtk3_5g7ct_116",
  "header-background": "awsui_header-background_5gtk3_5g7ct_119",
  "notifications": "awsui_notifications_5gtk3_5g7ct_123",
  "breadcrumbs": "awsui_breadcrumbs_5gtk3_5g7ct_128",
  "default-padding": "awsui_default-padding_5gtk3_5g7ct_133",
  "header-wrapper": "awsui_header-wrapper_5gtk3_5g7ct_137",
  "with-divider": "awsui_with-divider_5gtk3_5g7ct_142",
  "content": "awsui_content_5gtk3_5g7ct_145",
  "has-header": "awsui_has-header_5gtk3_5g7ct_149",
  "is-visual-refresh": "awsui_is-visual-refresh_5gtk3_5g7ct_156",
  "has-default-background": "awsui_has-default-background_5gtk3_5g7ct_156",
  "has-notifications": "awsui_has-notifications_5gtk3_5g7ct_160"
};
  